
function _stripInsignificantZeros(str, decimal) {
  const parts = str.split(decimal);
  const integerPart = parts[0];
  const decimalPart = parts[1].replace(/0+$/, '');

  if (decimalPart.length > 0) {
    return integerPart + decimal + decimalPart;
  }

  return integerPart;
}

export default _stripInsignificantZeros;



//////////////////
// WEBPACK FOOTER
// ./node_modules/accounting-js/lib/internal/stripInsignificantZeros.js
// module id = null
// module chunks = 